import React from 'react';
import Sprites from "styles/EG2023/EG2023sprites.svg";
import { Navbar, Nav, Container } from 'react-bootstrap'
import SelectorLanguageEG2023 from './Selector_Language';
import SelectorDiscipline from 'components/common/selectors/selector-discipline/selectorDiscipline';
import Label from 'components/general/Label';
import { useUrlFriendlyToParameters, useGetURL } from 'helpers/urlFriendly';
import { useLocation, useMatch, Link, useResolvedPath, useParams } from 'react-router-dom';
import { getURL } from 'helpers/utils';
import SelectorNoc from 'components/common/selectors/selector-noc';
import useViewport from "components/general/useViewPort";


const ElementsNavBar1 = () => {
    const location = useLocation();
    let pathUrl = location.pathname;
    let isDisciplines = useMatch({ path: "/:mirs_competition/:mirs_language/disciplines/*" }, pathUrl);
    let params = useParams();
    const sw = (pathUrl !== '/' && !isDisciplines)
    params.mirs_rsc = params.mirs_rsc || params.mirs_event_rsc

    //Copy object in order to change 
    let paramsURL = { ...params };
    let paramsRecords = { ...params };
    paramsRecords["mirs_discipline"] = "";


    //Change object if make changes over params make changes in componets related   (Change URL object)

    let url = getURL(paramsURL, 'schedule')
    let urlMedallists = useGetURL(paramsURL, 'medallists')
    let urlRecords = useGetURL(paramsRecords, 'records')


    return (

        <> {sw && <Nav.Link as={CustomLink} to={urlMedallists}><Label data={'LabelMedallists'} /></Nav.Link>}
            {sw && <SelectorNoc />}
            {sw && <SelectorDiscipline />}
            {sw && <Nav.Link as={CustomLink} to={url}><Label data={'LabelSchedule'} /></Nav.Link>}
            {sw && <Nav.Link as={CustomLink} to={urlRecords}><Label data={'LabelRecords'} /></Nav.Link>}

        </>
    )
}

const ElementsNavBar = () => {
    //const location = useLocation();
    //let pathUrl = location.pathname;
    //let isDisciplines = useMatch({ path: "/:mirs_competition/:mirs_language/disciplines/*" }, pathUrl);
    let params = useParams();
    //const sw = (pathUrl !== '/' && !hasDisciplines)
    params.mirs_rsc = params.mirs_rsc || params.mirs_event_rsc

    let paramsRecords = { ...params };
    paramsRecords["mirs_discipline"] = "";
    //let paramsAthletes = { ...params };

    //Copy object in order to change 
    let paramsURL = { ...params };
    paramsURL["mirs_date"] = "";
    paramsURL["mirs_discipline"] = "";
    paramsURL["mirs_event"] = "";
    paramsURL["mirs_noc"] = "";
    paramsURL["mirs_medal"] = "";


    //Change object if make changes over params make changes in componets related   (Change URL object)

    let urlAthletes = useGetURL(paramsURL, 'athletes')
    let urlSchedule = useGetURL(paramsURL, 'schedule')
    let urlMedallists = useGetURL(paramsURL, 'medallists')
    let urlRecords = useGetURL(paramsRecords, 'records')
    let urlCompetitionSchedule = useGetURL(paramsURL, 'competitionschedule')
    let urlMedal = useGetURL(params, 'medal')

    return (
        <>
            <Nav.Link as={CustomLink} to={urlCompetitionSchedule} eventKey="0"><Label data={'MenuSchedules'} /></Nav.Link>
            <Nav.Link as={CustomLink} to={urlAthletes} eventKey="0"><Label data={'LabelAthletes'} /></Nav.Link>
            <SelectorDiscipline page="schedule" />
            <Nav.Link as={CustomLink} to={urlRecords} eventKey="0"><Label data={'LabelRecords'} /></Nav.Link>
            <Nav.Link as={CustomLink} to={urlMedal} eventKey="0"><Label data={'LabelMedals'} /></Nav.Link>

            {/*<Nav.Link as={CustomLink} to={urlMedallists}><Label data={'LabelMedallists'} /></Nav.Link>*/}
        </>
    )
}



//HOC (Higth Order Component) component Link in order to style selected
function CustomLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });

    return (
        <div className="nav-schedule" >
            <Link
                to={to}
                {...props}
            >
                {children}
            </Link>
            {/* {match && " (active)"}*/}
        </div>
    );
}

export function HeaderEG2023() {
    const location = useLocation();
    const { breakPoint } = useViewport();

    // Eg2023 Mobile apps add this string to usen-agent
    const isMobileApp = Boolean(navigator.userAgent.match("Atos2023"))

    return (
        <>
            {(isMobileApp)
                ? ''
                :
                <Navbar collapseOnSelect expand="lg" sticky="top" id="mirs-first-navigation-bar">
                    <Container>
                        <Navbar.Brand className="d-flex">
                            <div className="EG2023-brand">
                                <div className="header-logo-wrapper">
                                    <div className="logo-wrapper dm dm-invert">
                                        <a href="https://www.european-games.org" title="European Games 2023">
                                            <svg className="dm logo-mobile eg">
                                                <use xlinkHref={`${Sprites}#logoeg2023`} />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbar-main" />
                        <Navbar.Collapse id="navbar-main">
                            <Nav active={location.pathname} className="ms-auto mb-lg-0">
                                <ElementsNavBar />
                            </Nav>
                            <SelectorLanguageEG2023 />
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            }
        </>
    )


};
export default HeaderEG2023